import {
  TeBadge,
  TeCell,
  TeContainer,
  TeContainerSlim,
  TeIcon,
  TeRow,
  TeTable,
  TeText,
} from '@topcon/tuicl-react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import IconWrapper from './IconWrapper';
import { AddressInfo } from '../api/generated/pm';

interface BusinessPartnerCardProps {
  badgeLabel?: string;
  name: string;
  subName: string;
  address: AddressInfo;
}

function BusinessPartnerCard({ badgeLabel, name, subName, address }: BusinessPartnerCardProps) {
  const { t } = useTranslation();

  return (
    <Wrapper
      backgroundColor="background.tertiary"
      padding={['xl', 'l']}
      fill
      grow
      column
      borderRadius="m"
      gap="m"
    >
      <>
        {badgeLabel && (
          <TeContainerSlim>
            <TeBadge size="s" backgroundColor="background.inverse" text={badgeLabel} />
          </TeContainerSlim>
        )}
        <TeContainerSlim gap="m" column fill>
          <IconWrapper size={64}>
            <TeIcon name="business" size="xl" />
          </IconWrapper>
          <TeContainerSlim column gap="xs2" fill>
            <TeText size={20} weight={700}>
              {name}
            </TeText>
            {subName && (
              <TeText size={12} weight={400} color="text.secondary">
                {subName}
              </TeText>
            )}
          </TeContainerSlim>
        </TeContainerSlim>
        <TeContainerSlim gap="xs" fill grow column>
          <TeTable evenOdd>
            <TeRow>
              <TeCell>
                <TeText color="text.secondary" size={12} weight={400}>
                  {t('officeAddress')}
                </TeText>
              </TeCell>
            </TeRow>
            {address?.addressLineOne && (
              <TeRow>
                <TeCell>
                  <TeText size={16} weight={500}>
                    {address.addressLineOne}
                  </TeText>
                </TeCell>
              </TeRow>
            )}
            {address?.addressLineTwo && (
              <TeRow>
                <TeCell>
                  <TeText size={16} weight={500}>
                    {address.addressLineTwo}
                  </TeText>
                </TeCell>
              </TeRow>
            )}
            {address?.zipPostalCode || address?.city ? (
              <TeRow>
                <TeCell>
                  <TeText size={16} weight={500}>
                    {address.zipPostalCode} {address.city}
                  </TeText>
                </TeCell>
              </TeRow>
            ) : null}
            {address?.country && (
              <TeRow>
                <TeCell>
                  <TeText size={16} weight={500}>
                    {address.country}
                  </TeText>
                </TeCell>
              </TeRow>
            )}
            {address?.stateProvinceRegion && (
              <TeRow>
                <TeCell>
                  <TeText size={16} weight={500}>
                    {address.stateProvinceRegion}
                  </TeText>
                </TeCell>
              </TeRow>
            )}
          </TeTable>
        </TeContainerSlim>
      </>
    </Wrapper>
  );
}

const Wrapper = styled(TeContainer)`
  width: 100% !important;
  height: 100% !important;
`;
export { BusinessPartnerCard };
